import React, { useState } from 'react'
import Modal from '../../modal'
import CloseSVG from '../../../../assets/svg/close.svg'
import { Initials } from '../../../../utils/functions'
import {
  useAddQueryMessage,
  useChangeQueryStatus,
  useGetQueryMessage,
} from '../../../../redux/human-resources/hook/queries'
import Button from '../../../button'

const TrackQuery = ({ isOpen, setTrackQuery, setShowAddQuery, query }) => {
  const [inputValue, setInputValue] = useState('')

  const { mutateAsync: addQueryMessage, isLoading: addQueryMessageloading } =
    useAddQueryMessage()

  const {
    refetch: refetchMessages,
    data: queryMessage,
    isLoading: messageLoading,
  } = useGetQueryMessage(query?.id)

  const submitForm = async () => {
    if (!inputValue.trim()) return

    let payload = {
      comment: inputValue,
      query_id: query?.id,
    }
    await addQueryMessage(payload).then(() => {
      refetchMessages()
      setInputValue('')
    })
  }

  const { mutateAsync: resolve, isLoading: resolveLoading } =
    useChangeQueryStatus()

  const changeQueryStatus = async () => {
    let payload = {
      id: query?.id,
      data: { status: query?.status == 1 ? 0 : 1 },
    }
    await resolve(payload).then(() => {
      setTrackQuery(false)
      setShowAddQuery && setShowAddQuery(false)
    })
  }

  return (
    <Modal
      scrollable={true}
      className='md:!w-[600px] !w-[95%]'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col p-3 w-full overflow-auto'>
        <div className='flex justify-between w-full items-center'>
          <div className='flex gap-3 items-center'>
            <div className='flex font-bold justify-center items-center h-[40px] w-[40px] rounded-[10px] header-4 border-2 border-secondary-2 bg-green-200'>
              {Initials(query?.first_name, query?.last_name)}
            </div>
          </div>
          <div
            className='cursor-pointer'
            onClick={() => {
              setTrackQuery(false)
              setShowAddQuery && setShowAddQuery(false)
            }}
          >
            <img src={CloseSVG} alt='' />
          </div>
        </div>
        <hr className='w-full my-2 h-[2px] bg-[#96969B]' />
        <div className='w-full flex justify-between items-center'>
          <p className='text-[18px] font-medium'>
            {query?.first_name + ' ' + query?.last_name}{' '}
          </p>
          {query?.status !== 1 && (
            <div>
              <Button
                text='Resolve Query'
                type='button'
                leftIcon={'check'}
                className='flex gap-2 !h-[40px] w-[170px] p-2 '
                onClick={() => {
                  changeQueryStatus()
                }}
                disabled={resolveLoading}
                loading={resolveLoading}
                textClass={'!text-[16px]'}
              />
            </div>
          )}
        </div>

        <div className='flex flex-col gap-4 w-full max-h-[400px] overflow-y-auto py-2'>
          <main className='flex flex-col gap-4 w-[95%] mx-auto h-full py-2'>
            {queryMessage?.length === 0 ? (
              <div className='flex items-center justify-center font-bold text-base text-center my-10'>
                Send messages to {query?.first_name} {query?.last_name}{' '}
              </div>
            ) : (
              queryMessage?.map((msg) => (
                <div
                  key={msg.id}
                  className={`flex ${
                    msg.sender_name === 'HR' ? 'justify-end' : 'justify-start'
                  }`}
                >
                  <div className='max-w-[70%]'>
                    <div className='text-xs text-gray-500 mb-1'>
                      {msg.sender_name}
                    </div>
                    <div
                      className={`rounded-lg px-3 py-2 text-sm ${
                        msg.sender_name === 'HR'
                          ? 'bg-hr-primary-1 text-white'
                          : 'bg-gray-200'
                      }`}
                    >
                      {msg.comment}
                    </div>
                  </div>
                </div>
              ))
            )}
          </main>
        </div>

        {query.status !== 1 && (
          <div className='flex gap-3 items-center'>
            <input
              type='text'
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              placeholder='Send a reply'
              className='w-[75%] h-[52px] px-3 border border-[#96969B] rounded-lg text-sm placeholder:text-sm outline-none text-inherit'
            />
            <Button
              text={'Send'}
              type='button'
              disabled={addQueryMessageloading}
              onClick={() => {
                submitForm()
              }}
              textClass={'!text-[16px]'}
              className={'h-[52px] w-[25%] font-medium'}
              loading={addQueryMessageloading}
            />
          </div>
        )}
      </div>
    </Modal>
  )
}

export default TrackQuery
